export default __webpack_public_path__ + "static/media/thdjbr-logo-horiz.f5a30ba2.svg";